/* @flow */
import React from 'react';
import Box from 'components/Box.jsx';
import BoxBody from 'components/BoxBody.jsx';
import Columns2 from 'components/Columns2.jsx';
import DialogContent from 'components/DialogContent.jsx';
import JoinSignUpForm from './JoinSignUpForm.jsx';
import ResponsiveMixin from 'components/mixins/ResponsiveMixin';
import JoinSignUpPageLeftPanel from './JoinSignUpPageLeftPanel.jsx';

const JoinSignUpPage = React.createClass({
  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    ResponsiveMixin,
  ],

  statics: {
    SMALL: 700,
  },

  onUserCreate() {
    this.context.router.push('/landing');
  },

  render() {
    if (this.isComponentSize(JoinSignUpPage.SMALL)) {
      return (
        <DialogContent size="large" full>
          <Box className="AuthenticationView-box">
            <BoxBody>
              <JoinSignUpForm onUserCreate={this.onUserCreate} />
            </BoxBody>
          </Box>
        </DialogContent>
      );
    }

    return (
      <DialogContent size="large" full>
        <Box className="AuthenticationView-box">
          <BoxBody>
            <Columns2>
              <div className="JoinSignUpPage-LeftPanel">
                <JoinSignUpPageLeftPanel />
              </div>
              <JoinSignUpForm onUserCreate={this.onUserCreate} />
            </Columns2>
          </BoxBody>
        </Box>
      </DialogContent>
    );
  },
});

export default JoinSignUpPage;



// WEBPACK FOOTER //
// ./src/join/components/JoinSignUpPage.jsx